// @flow
import React from 'react';
import '../../../static/scss/components/policies/policiesWrapper.scss';

type Props = {
  children: any
};

const PoliciesWrapper = ({ children }: Props) => (
  <div className="c-policies-wrapper">{children}</div>
);

export default PoliciesWrapper;
